/**
 * Korean translations
 */
import type { TranslationKeys } from '../utils/i18n';

export const ko: TranslationKeys = {
  controls: {
    maxTime: '최대 시간',
    maxTimeMinutes: '최대 시간 (분)',
    travelMode: '이동 수단',
    speed: '속도',
    mapStyle: '지도 스타일',
    language: '언어',
    share: '공유',
    play: '재생',
    pause: '일시 정지',
    restart: '다시 시작',
    loading: '로딩 중...',
    showControls: '컨트롤 표시',
    hideControls: '컨트롤 숨기기',
    expandControls: '컨트롤 확장',
    collapseControls: '컨트롤 접기',
    selectLocationHint: '지도에서 위치를 선택하여 시작하세요',
  },
  travelModes: {
    driving: '자동차',
    walking: '도보',
    cycling: '자전거',
    transit: '대중교통',
  },
  speed: {
    verySlow: '0.1x (매우 느림)',
    slow: '0.25x (느림)',
    half: '0.5x (절반)',
    normal: '1x (보통)',
    fast: '1.5x (빠름)',
    veryFast: '2x (매우 빠름)',
  },
  mapStyles: {
    streets: '거리',
    satellite: '위성',
  },
  languages: {
    en: 'English',
    'zh-Hans': '简体中文 (Simplified Chinese)',
    'zh-Hant': '繁體中文 (Traditional Chinese)',
    es: 'Español (Spanish)',
    fr: 'Français (French)',
    de: 'Deutsch (German)',
    ja: '日本語 (Japanese)',
    ko: '한국어 (Korean)',
  },
  addressInput: {
    label: '주소 검색',
    placeholder: '주소를 입력하여 시간 지도 계산',
    noResults: '결과를 찾을 수 없습니다',
    loading: '제안 로딩 중',
  },
  error: {
    retry: '다시 시도',
    dismiss: '오류 닫기',
    somethingWentWrong: '문제가 발생했습니다. 페이지를 새로고침하세요.',
    browserNotSupported: '브라우저가 이 애플리케이션을 지원하지 않습니다. 최신 브라우저를 사용하세요.',
    usageLimitReached: '베타 제한인 5회 계산에 도달했습니다. 사용해 주셔서 감사합니다! 이 프로젝트에 관심이 있으시면 DM 보내주세요.',
  },
  progress: {
    minutes: '분',
  },
  share: {
    urlCopied: 'URL이 클립보드에 복사되었습니다!',
    shareUrl: 'URL 공유',
  },
  emailGate: {
    title: '시간 지도 Beta에 로그인',
    subtitle: '이메일 주소를 입력하여 로그인 링크를 받으세요',
    emailPlaceholder: 'your.email@example.com',
    emailLabel: '이메일 주소',
    sendButton: '로그인 링크 보내기',
    sendingButton: '로그인 링크 전송 중...',
    checkEmailTitle: '이메일을 확인하세요',
    checkEmailMessage: '{email}로 로그인 링크를 보냈습니다',
    checkEmailInstruction: '이메일의 링크를 클릭하여 시간 지도로 이동하세요.',
    checkEmailHelp: '이메일을 받지 못했나요? 스팸 폴더를 확인하거나 다른 이메일 주소로 다시 시도하세요.',
    emailRequired: '이메일 주소를 입력하세요',
    emailInvalid: '유효한 이메일 주소를 입력하세요',
    domainRestriction: '베타 액세스는 @gmail.com, @outlook.com 및 @qq.com 이메일 주소만 허용됩니다.',
    domainNotAllowed: '베타 액세스는 현재 Gmail, Outlook 및 QQ 이메일 주소로 제한됩니다',
    typoSuggestion: '@{domain}을(를) 의미하셨나요?',
    rateLimitExceeded: '요청이 너무 많습니다. 잠시 기다렸다가 다시 시도하세요.',
    invalidEmailFormat: '유효하지 않은 이메일 주소입니다. 확인 후 다시 시도하세요.',
    failedToSend: '로그인 링크 전송에 실패했습니다. 다시 시도하세요.',
    magicLinkFailed: '매직 링크 전송 실패: {error}',
    testMeButton: '테스트',
    bannerText: '시간 지도',
    betaTag: '베타',
  },
  testCode: {
    title: '테스트 코드 입력',
    subtitle: '테스트 코드가 있으신가요? 아래에 입력하여 시작하세요',
    placeholder: '코드 입력',
    button: '코드로 계속',
    haveCodeLink: '테스트 코드가 있으신가요?',
    useEmailLink: '대신 이메일 사용',
    invalid: '유효하지 않은 테스트 코드',
    expired: '이 테스트 코드는 만료되었습니다',
    limitReached: '이 테스트 코드는 사용 한도에 도달했습니다',
    optionalEmailTitle: '진행 상황 저장 (선택 사항)',
    optionalEmailSubtitle: '작업을 저장하시겠습니까? 아래에 이메일을 입력하세요 (또는 건너뛰기)',
    optionalEmailPlaceholder: 'your.email@example.com (선택 사항)',
    skipButton: '지금은 건너뛰기',
    submitEmailButton: '계속',
  },
  usageIndicator: {
    template: '계산 {count}회 남음',
    loading: '로딩 중...',
  },
  disclaimer: {
    loading: '로딩 중...',
    title: '중요 고지사항',
    content: '이것은 베타 및 실험 프로젝트입니다. 모든 지도 데이터는 제3자 서비스인 Mapbox에서 제공하며 독립적으로 검증되지 않았습니다. 지도에는 부정확한 정보가 포함될 수 있으며 중요한 결정에 의존해서는 안 됩니다. 여행 시간 계산은 추정치일 뿐이며 정확성이 검증되지 않았습니다. 본 애플리케이션 사용으로 인한 부정확성, 오류 또는 결과에 대해 어떠한 책임도 지지 않습니다.',
    consent: '본 애플리케이션을 계속 사용함으로써 귀하는 위의 모든 약관 및 면책 조항을 인정하고 수락합니다.',
  },
  intro: {
    title: '당신의 도달 범위 발견',
    message: '어떤 위치에서든 주어진 시간 내에 얼마나 멀리 이동할 수 있는지 시각화하세요.\n\n지도에서 애니메이션으로 표시되는 이동 시간 도달 범위를 보고 거주, 근무 또는 방문 장소에 대해 더 나은 결정을 내리세요.',
    step1: '지도를 검색하거나 클릭하여 출발점을 설정하세요',
    step2: '지도는 애니메이션 영역으로 이동 시간 도달 범위를 표시합니다',
    step3: '이동 시간과 교통 수단을 설정하세요',
    step4: '재생을 클릭하여 시간이 지남에 따라 도달 범위가 확장되는 것을 확인하세요',
    step5: '공유 가능한 링크를 통해 다른 사람들과 시각화를 공유하세요',
    next: '다음',
    skip: '투어 건너뛰기',
    gotIt: '알겠습니다!',
    startTour: '투어 시작',
  },
};

